export const GET_SINGLE_ORGANIZATION_START =
  'GET_SINGLE_ORGANIZATION_START';
export const GET_SINGLE_ORGANIZATION_END =
  'GET_SINGLE_ORGANIZATION_END';
export const GET_SINGLE_ORGANIZATION_SUCCESS =
  'GET_SINGLE_ORGANIZATION_SUCCESS';
export const GET_SINGLE_ORGANIZATION_FAILURE =
  'GET_SINGLE_ORGANIZATION_FAILURE';
